import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, FormGroup, Label, Input } from 'reactstrap';
import moment from 'moment';
import AppButton from './common/AppButton';

const DateRangeFilter = ({ onSearch, buttonLabel = 'Go', initialFrom, initialTo, fromColWidth = 3, toColWidth = 3 }) => {
  const [dates, setDates] = useState({
    from: initialFrom || moment().startOf('month').format('YYYY-MM-DD'),
    to: initialTo || moment().endOf('month').format('YYYY-MM-DD'),
  });

  const handleSearch = () => {
    if (onSearch) {
      onSearch({
        from: dates.from,
        to: dates.to,
        fromFull: `${dates.from} 00:00:00`,
        toFull: `${dates.to} 23:59:59`,
      });
    }
  };

  return (
  <Row className="g-2 align-items-end">
        <Col lg={fromColWidth}>
          <FormGroup className="mb-0">
            <Label className="mb-2">From Date</Label>
            <Input
              type="date"
              value={dates.from}
              onChange={(e) =>
                setDates({
                  ...dates,
                  from: e.target.value,
                })
              }
              className="date-range-input"
            />
          </FormGroup>
        </Col>

        <Col lg={toColWidth}>
          <FormGroup className="mb-0">
            <Label className="mb-2">To Date</Label>
            <Input
              type="date"
              value={dates.to}
              onChange={(e) =>
                setDates({
                  ...dates,
                  to: e.target.value,
                })
              }
              className="date-range-input"
            />
          </FormGroup>
        </Col>

        <Col lg={2}>
          <div className="btn-go-wrapper">
            <FormGroup className="w-100 mb-0">
              <AppButton
                label={buttonLabel}
                variant="buttonColor"
                onClick={handleSearch}
                className="date-range-button"
              />
            </FormGroup>
          </div>
        </Col>
      </Row>
    
  );
};

DateRangeFilter.propTypes = {
  onSearch: PropTypes.func,
  buttonLabel: PropTypes.string,
  initialFrom: PropTypes.string,
  initialTo: PropTypes.string,
  fromColWidth: PropTypes.number,
  toColWidth: PropTypes.number,
};

export default DateRangeFilter;
